import { adminMarketingQueryKeys as e } from "./adminMarketingQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminMarketingApi as r } from "@maat/api-main";
//#region src/marketing/admin/useUpdateMarketingAssetMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.update(e.id, e.data),
		onSuccess: (t, n) => {
			i.invalidateQueries({ queryKey: e.list() }), i.invalidateQueries({ queryKey: e.detail(n.id) });
		}
	});
};
//#endregion
export { i as useUpdateMarketingAssetMutation };
